export default "__VITE_ASSET__DRFm60ZZ__"